export enum AccessLevel {
    None = 0,
    Viewer = 1,
    Guest = 2,
    Tester = 3,
    Admin = 4,
    SysAdmin = 5
}

// The editor-role strings stored per user in PlayFab InternalData (`editorRole`)
// and accepted by the backend `setUserRole` endpoint. These strings — NOT the
// numeric AccessLevel above — are what persists; the enum is only ever derived
// from them at runtime (backend Secret.RoleToAccessLevel), so the enum can be
// renumbered freely as long as this list and that mapping stay in sync.
// Order is ascending privilege.
export const EDITOR_ROLES = ['none', 'viewer', 'guest', 'tester', 'admin', 'sysadmin'] as const;
export type EditorRole = typeof EDITOR_ROLES[number];

// Display labels for the role dropdown, keyed by the persisted string.
export const EDITOR_ROLE_LABELS: Record<EditorRole, string> = {
    none: 'None',
    viewer: 'Viewer',
    guest: 'Guest',
    tester: 'Tester',
    admin: 'Admin',
    sysadmin: 'SysAdmin',
};
